import { GET_BOOKINGS_REQUEST, GET_ASSIGNED_OO_REQUEST, GET_REQUESTS } from 'redux/actions/Workbook';
import { GET_BOOKINGS, GET_ASSIGNED_OO } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  dispatches: [],
  users: [],
  requests: [],
  totalBookings: 0,
  totalAssignedOO: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BOOKINGS: {
      return {
        ...state,
        dispatches: action.payload && action.payload.dispatches,
        totalBookings: action.payload && action.payload.total_count,
      };
    }
    case GET_ASSIGNED_OO: {
      return {
        ...state,
        users: action.payload && action.payload,
        totalAssignedOO: action.payload && action.payload.total_count,
      };
    }
    case GET_REQUESTS: {
      return {
        ...state,
        requests: action.payload,
      };
    }
    default:
      return state;
  }
};
